import Button from "./button";

function QuizPage({
  question,
  mode,
  onSelected,
  onNext,
  selectedAnswer,
  numberOfQuestions,
  currentQuestion,
}) {
  return (
    <div className="flex flex-col items-center justify-center w-full h-screen gap-8">
      <h2 className="font-bold text-center text-primary">
        Questions {currentQuestion + 1} of {numberOfQuestions}
      </h2>
      <h2 className="text-2xl font-bold text-center text-primary">
        {question.question}
      </h2>
      <div
        className={
          mode === "question"
            ? "flex flex-col items-center w-full"
            : "flex flex-col items-center w-full gap-8"
        }
      >
        <div className="grid w-full grid-cols-2 gap-4">
          {question.answers.map((answer, index) => (
            <Button
              key={index}
              state={
                mode === "question"
                  ? "selectable"
                  : index === question.correctIndex
                  ? mode === "correct"
                    ? "correct"
                    : "correctOther"
                  : index === selectedAnswer
                  ? "wrong"
                  : "other"
              }
              text={answer}
              onClick={() => onSelected(index)}
            ></Button>
          ))}
        </div>
        {mode !== "question" && (
          <button
            className="px-8 py-3 text-center text-white border-2 rounded-full border-blue bg-blue hover:bg-blue/80"
            type="button"
            onClick={onNext}
          >
            Next Question
          </button>
        )}
      </div>
    </div>
  );
}

export default QuizPage;
